import axios from "axios";
import { refreshSessionOrLogout } from "./interceptors";
import { commonHeaders } from "./commonHeader";
import TokenService from "./tokenManager";
import { API_BASE_URL } from "config";

const documentClient = axios.create({
  // baseURL: "https://digitallending.accessbankplc.com:9091",
  baseURL: API_BASE_URL,

  headers: commonHeaders,
});

documentClient.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      if (config.headers) config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

documentClient.interceptors.response.use((res) => {
  return res;
}, refreshSessionOrLogout());

export default documentClient;
